import { render, staticRenderFns } from "./ProjectCreatedNotification.vue?vue&type=template&id=3396f15c&scoped=true&"
import script from "./ProjectCreatedNotification.vue?vue&type=script&lang=js&"
export * from "./ProjectCreatedNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3396f15c",
  null
  
)

export default component.exports